import type {
  NormalizedProvisionWorkspaceInput,
  ProvisionWorkspaceInput
} from "../adminProvisioning";

export interface ProvisionedSetupLink {
  userId: string;
  email: string;
  role: "owner" | "contributor";
  setupLink: string;
  expiresAt: string;
  emailSent?: boolean;
  emailError?: string;
}

export interface ProvisionWorkspaceResult {
  organization: {
    id: string;
    name: string;
  };
  workspace: {
    id: string;
    name: string;
  };
  owner: {
    id: string;
    email: string;
  };
  departments: Array<{
    id: string;
    name: string;
    contributorUserId?: string;
    contributorEmail?: string;
  }>;
  setupLinks: ProvisionedSetupLink[];
}

async function parseJson<T>(response: Response): Promise<T> {
  return (await response.json()) as T;
}

async function assertOk(response: Response): Promise<void> {
  if (response.ok) return;
  const data = await response.json().catch(() => undefined) as { error?: string } | undefined;
  throw new Error(data?.error ?? "Workspace konnte nicht provisioniert werden.");
}

export async function provisionWorkspace(input: ProvisionWorkspaceInput | NormalizedProvisionWorkspaceInput): Promise<ProvisionWorkspaceResult> {
  const response = await fetch("/api/admin/provision-workspace", {
    method: "POST",
    headers: { "content-type": "application/json" },
    credentials: "include",
    body: JSON.stringify(input)
  });
  await assertOk(response);
  return parseJson<ProvisionWorkspaceResult>(response);
}
